import React, {
    useState,
    useEffect
}                       from "react";
import { Link }         from "react-router-dom";
import Dropdown         from './dropdown'

const NavbarItem = props => {
    const p                   = props
    const [icon, setIcon]     = useState(true);
    const [screen, setScreen] = useState(true);
    const handleClick         = () => setIcon(!icon);

    const showButton = () => {
      if (window.innerWidth <= 960) {
        setIcon(false);
        setScreen(true)
    } else {
        setIcon(true);
        setScreen(false)
      }
    };
  
    useEffect(() => {
      showButton();
    }, []);
  
    window.addEventListener("resize", showButton);
    
    return (
        <div className="nav-item">
            <Link
                className="nav-links"
                to={p.to}
                onClick={p.closeMobileMenu}
            >
                { p.children }
            </Link>
            { p.itemName && screen && <i className="fas fa-caret-down" onClick={handleClick} /> }
            { p.itemName && icon && <Dropdown itemName = { p.itemName } open={icon} /> }
        </div>
    )
}

export default NavbarItem
